import React, { useState, } from "react";
import { BtnAdd, BtnCancelar, BtnDeletar, BtnEdit } from "../../../components/Buttons";
import Mensagens from "../../../components/Mensagens";
import EnderecoForm from './EnderecoForm';

export default function PessoaEnderecos({ enderecos = [], setEnderecos, tabIndex }) {
    const [detalhe, setDetalhe] = useState(null);

    const confirmar = () => {
        if (!detalhe.cep) return Mensagens.showErro("Cep não informado!");
        if (!detalhe.logradouro) return Mensagens.showErro("Logradouro não informado!");
        if (!detalhe.bairro) return Mensagens.showErro("Bairro não informado!");
        if (!detalhe.cidade) return Mensagens.showErro("Cidade não informada!");
        if (!detalhe.uf) return Mensagens.showErro("UF não informada!");
        if (!detalhe.numero) return Mensagens.showErro("Número não informado!");

        const aux = [...enderecos];
        var endereco = aux.find(x => x.id == detalhe.id);

        if (endereco == null)
            aux.push(detalhe);
        else
            aux[aux.findIndex(x => x.id == detalhe.id)] = detalhe;

        setEnderecos(aux);
        setDetalhe(null);
    };

    const remover = id => {
        const aux = [...enderecos];
        aux.find(x => x.id === id).isExcluido = true;
        setEnderecos(aux);
    };

    return <>
        <div>
            {enderecos?.filter(x => !x.isExcluido)?.map(x => {
                return <div style={{ display: 'flex', marginTop: 7 }}>
                    <p>{`${x.cep} ${!!x.logradouro ? " / " + x.logradouro : ""} ${!!x.numero ? " / " + x.numero : ""} ${!!x.complemento ? " / " + x.complemento : ""} ${!!x.bairro ? " / " + x.bairro : ""} ${!!x.cidade ? " / " + x.cidade : ""} ${!!x.estado ? " / " + x.estado : ""}`}</p>
                    {!detalhe && (<div style={{ flex: 1, marginLeft: 15 }}>
                        <BtnEdit onClick={() => setDetalhe(x)} />
                        <BtnDeletar onOk={() => remover(x.id)} style={{ marginLeft: 10 }} />
                    </div>)}
                </div>;
            })}

            {!detalhe && <BtnAdd onClick={() => setDetalhe({ id: 0 - enderecos.length })} />}
        </div>

        {detalhe && <>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 25 }}>
                <BtnAdd onClick={confirmar} style={{ marginRight: 10 }} />
                <BtnCancelar onClick={() => setDetalhe(null)} />
            </div>
            <EnderecoForm disableForm object={detalhe} setObject={x => setDetalhe({ ...detalhe, ...x })} onOk={confirmar} tabIndex={tabIndex} />
        </>}
    </>;
}
